var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7288 0.271197C9.36721 -0.0903991 8.78094 -0.0903991 8.41935 0.271197L0.271197 8.41935C-0.0903988 8.78094 -0.0903988 9.36721 0.271197 9.7288C0.632794 10.0904 1.21906 10.0904 1.58066 9.7288L9.7288 1.58065C10.0904 1.21906 10.0904 0.632794 9.7288 0.271197Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.271197 0.271197C0.632794 -0.0903991 1.21906 -0.0903991 1.58065 0.271197L9.7288 8.41934C10.0904 8.78094 10.0904 9.3672 9.7288 9.7288C9.36721 10.0904 8.78094 10.0904 8.41934 9.7288L0.271197 1.58065C-0.0903991 1.21906 -0.0903991 0.632794 0.271197 0.271197Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/X-icon.53d69c18b2d731cce68e2642c3f46c07.svg";
export { ForwardRef as ReactComponent };